import { MainCheckInContext } from '@/context/MainCheckIn/MainCheckInContext';
import { useContext } from 'react';

export const useMainCheckIn = () => {
    const {
        setModal,
        mainCheckInState,
        setFormData,
        setSettleFlat,
        addDataTable,
        removeDataTable,
        removeItemDataTable,
        setKeyTable,
        setEventModalDiscount,
        setEventModalCredit,
        setQuaDem,
        setLoaiPhong,
        setDataCheckIn,
    } = useContext(MainCheckInContext);

    return {
        mainCheckInState,
        setModal,
        setFormData,
        addDataTable,
        removeDataTable,
        removeItemDataTable,
        setSettleFlat,
        setKeyTable,
        setEventModalDiscount,
        setEventModalCredit,
        setQuaDem,
        setLoaiPhong,
        setDataCheckIn,
    };
};
